import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import _ from 'lodash'

// components
import { Button, TextInputWithIcon, Icon } from 'components/shard'

// const
import { Size, Color } from 'const'
import Alert from 'components/Alert'

import { usePasswordHook } from 'hooks'

function PasswordReset() {
  const [values, setValues] = useState({})
  const [show, setShow] = useState(false)
  const {
    token,
    errors,
    setErrors,
    resetSchema,
    execResetPassword,
    isResettingPassword,
    isSuccess,
    history,
  } = usePasswordHook()

  useEffect(() => {
    if (_.isEmpty(values)) {
      return
    }

    execResetPassword(token, values.password)
  }, [values, execResetPassword, token])

  useEffect(() => {
    if (isSuccess) {
      history.push('/password/reset/complate')
    }
  }, [history, isSuccess])

  const handleIconPasswordClick = () => {
    setShow(!show)
  }

  return (
    <Wrapper>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <Title>パスワード再設定</Title>
      <Message>新たなパスワードを入力してください</Message>
      <FormWrapper>
        <Formik
          initialValues={{ password: '' }}
          onSubmit={(values) => {
            setValues(values)
          }}
          validationSchema={resetSchema}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isValid }) => (
            <form
              onSubmit={(e) => {
                handleSubmit(e)
                e.preventDefault() // useEffectでstateを更新するためにcomponentの自動更新を防ぐ
              }}
            >
              <TextInputWithIcon
                type={show ? 'text' : 'password'}
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                ariaLabel="password"
                placeholder="パスワード"
                errorMessage={<ErrorMessage name="password" />}
                subfix={<Icon icon={show ? 'eye' : 'eye-blocked'} size="16" />}
                subfixClick={handleIconPasswordClick}
                width="100%"
              />
              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isResettingPassword}>
                  パスワードを設定する
                </Button>
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 80px 100px 50px 400px 1fr;
`

const Title = styled.div`
  grid-row: 2;
  display: flex;
  align-items: flex-end;
  font-size: ${Size.FONT.HEADLINE.LEARGE};
  padding-bottom: 20px;
`

const Message = styled.div`
  grid-row: 3;
  padding: 8px 0;
  color: ${Color.FONT.ANNOTATION};
  border-bottom: 1px solid ${Color.LINE.NORMAL};
`

const FormWrapper = styled.div`
  grid-row: 4;
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 32px;
`

PasswordReset.propTypes = {
  values: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLogin: PropTypes.func,
}

export default PasswordReset
